// extracted by mini-css-extract-plugin
export var container = "_7g-0";
export var error = "_7g-9";
export var label = "_7g-5";
export var light = "_7g-6";
export var md = "_7g-3";
export var sm = "_7g-2";
export var thin = "_7g-8";
export var thinBold = "_7g-7";
export var vertical = "_7g-4";
export var xs = "_7g-1";